var map = {
	"./arb.svg": 55491,
	"./arrow-up.svg": 92601,
	"./arrow.svg": 27933,
	"./bid.svg": 67447,
	"./boxes.svg": 56597,
	"./caret-up.svg": 27111,
	"./cbETH.svg": 40906,
	"./check.svg": 87486,
	"./claim.svg": 78410,
	"./close-icon.svg": 30884,
	"./collateral.svg": 98605,
	"./connectors/arrow-right.svg": 92181,
	"./connectors/coinbaseWalletIcon.svg": 31125,
	"./connectors/gnosisWalletIcon.svg": 86748,
	"./connectors/metamask-fox.svg": 53530,
	"./connectors/walletConnectIcon.svg": 51475,
	"./cookie.svg": 88144,
	"./curve.svg": 90975,
	"./dark-arrow.svg": 42734,
	"./debt.svg": 79761,
	"./discord.svg": 32338,
	"./error.svg": 37956,
	"./eth-icon.svg": 49775,
	"./eth-img.svg": 40025,
	"./flx-logo.svg": 52736,
	"./flx_uni_eth.svg": 89339,
	"./flx_uni_hai.svg": 76988,
	"./footer-bg-art.svg": 92653,
	"./incentive.svg": 54241,
	"./magic.svg": 60627,
	"./mine.svg": 34019,
	"./nfts-icon.svg": 98753,
	"./od-full-logo-dark.svg": 98378,
	"./od-full-logo-grey.svg": 78087,
	"./od-full-logo-light.svg": 53202,
	"./od-logo-grey.svg": 95135,
	"./od-logo.svg": 75377,
	"./odg.svg": 85990,
	"./op-img.svg": 74725,
	"./parachute-icon.svg": 78415,
	"./plus.svg": 14066,
	"./pufeth.svg": 79620,
	"./rETH.svg": 57161,
	"./sell-od.svg": 52306,
	"./siren.svg": 24149,
	"./stETH.svg": 21420,
	"./staking.svg": 18729,
	"./surplus.svg": 82000,
	"./tx-failed-icon.svg": 66362,
	"./tx-submitted-icon.svg": 76228,
	"./tx-waiting-for-confirmation-icon.svg": 77122,
	"./uniswap-icon.svg": 75133,
	"./unknown-token.svg": 76748,
	"./wallet-icon.svg": 59261,
	"./wsteth.svg": 54265
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 91980;